export default "__VITE_ASSET__666e980c__"